<div class="feedback__modal" v-if="isOpen">
    <div class="feedback__modal-wrap">
        <div class="feedback__modal-close" @click="closeModal">
            <svg>
                <use xlink:href="#svg_circle_close"></use>
            </svg>
        </div>
        <div class="feedback__modal-content">
            <div class="feedback-image__container">
                <img v-if="pathImage"
                     :src="require('../../assets/contest/' + pathImage)"
                     class="feedback-image__picture"
                     :class="voted ? 'feedback-image__picture--rotate' : ''"
                     alt="Feedback image">

                <div v-if="flag" class="feedback-image__rating">
                    <i class="icon-mb-like-selected"></i>
                </div>
            </div>

            <h2 v-if="title" v-html="title"></h2>
            <div v-if="description" v-html="description" class="feedback__modal-description"></div>
            <div v-if="textCta && linkCta">
                <a class="button more-padding brown-button" :href="linkCta">{{ textCta }}</a>
            </div>
        </div>
    </div>
</div>